import React, { useState, useEffect } from "react";


function TourOverView({ tourOverview, setTourOverview }) {




    const handleOverviewChange = (e) => {
        const { name, value } = e.target;
        setTourOverview((prev) => ({ ...prev, [name]: value }));
    };

    const handleBulletChange = (index, value) => {
        const updated = [...tourOverview.bullets];
        updated[index] = value;
        setTourOverview((prev) => ({ ...prev, bullets: updated }));
    };

    const addBullet = () => {
        setTourOverview((prev) => ({
            ...prev,
            bullets: [...prev.bullets, ""],
        }));
    };

    const removeBullet = (index) => {
        setTourOverview((prev) => ({
            ...prev,
            bullets: prev.bullets.filter((_, i) => i !== index),
        }));
    };



    return (
        <section className="space-y-4 mt-6">
            <h2 className="text-xl font-bold">Tour Overview</h2>

            {/* TITLE */}
            <div className="space-y-1">
                <label className="text-sm text-gray-600">Tour Title</label>
                <input
                    type="text"
                    name="title"
                    className="w-full p-2 border rounded"
                    value={tourOverview.title}
                    onChange={handleOverviewChange}
                />
            </div>

            {/* LOCATION */}
            <div className="space-y-1">
                <label className="text-sm text-gray-600">Location</label>
                <input
                    type="text"
                    name="location"
                    className="w-full p-2 border rounded"
                    value={tourOverview.location}
                    onChange={handleOverviewChange}
                />
            </div>

            {/* RATING BLOCK */}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="space-y-1">
                    <label className="text-sm text-gray-600">Rating</label>
                    <select
                        name="rating"
                        className="p-2 border rounded w-full"
                        value={tourOverview.rating}
                        onChange={handleOverviewChange}
                    >
                        <option value="">Select Rating</option>
                        <option value="1">1.0</option>
                        <option value="1.5">1.5</option>
                        <option value="2">2.0</option>
                        <option value="2.5">2.5</option>
                        <option value="3">3.0</option>
                        <option value="3.5">3.5</option>
                        <option value="4">4.0</option>
                        <option value="4.5">4.5</option>
                        <option value="5">5.0</option>
                    </select>

                </div>

                <div className="space-y-1">
                    <label className="text-sm text-gray-600">Total Reviews</label>
                    <input
                        type="number"
                        name="review_count"
                        className="p-2 border rounded w-full"
                        value={tourOverview.review_count}
                        onChange={handleOverviewChange}
                    />
                </div>

                <div className="space-y-1">
                    <label className="text-sm text-gray-600">Recommendation %</label>
                    <input
                        type="number"
                        name="recommendation_percent"
                        className="p-2 border rounded w-full"
                        value={tourOverview.recommendation_percent}
                        onChange={handleOverviewChange}
                    />
                </div>
            </div>


            {/* SUB TITLE */}
            <div className="space-y-1">
                <label className="text-sm text-gray-600">Subtitle</label>
                <input
                    type="text"
                    name="subtitle"
                    className="w-full p-2 border rounded"
                    value={tourOverview.subtitle}
                    onChange={handleOverviewChange}
                />
            </div>

            {/* BULLET POINTS */}
            <div className="space-y-2">
                {/* <div className="flex justify-between items-center">
                    <label className="text-sm text-gray-600">Bullet Points</label>
                    <button
                        type="button"
                        onClick={addBullet}
                        className="px-2 py-1 bg-gray-100 rounded"
                    >
                        +
                    </button>
                </div> */}
{/* 
                {(tourOverview.bullets || []).map((point, i) => (
                    <div key={i} className="space-y-1">
                        <label className="text-xs text-gray-500">
                            Point {i + 1}
                        </label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                className="flex-1 p-2 border rounded"
                                value={point}
                                onChange={(e) => handleBulletChange(i, e.target.value)}
                            />
                            {i > 0 && (
                                <button
                                    type="button"
                                    onClick={() => removeBullet(i)}
                                    className="text-red-600"
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    </div>
                ))} */}

                <div className="space-y-1 mt-3">
                    <label className="text-sm text-gray-600">Read More</label>
                    <textarea
                        name="read_more_text"
                        className="w-full p-2 border rounded"
                        rows={4}
                        value={tourOverview.read_more_text}
                        onChange={handleOverviewChange}
                    />
                </div>
            </div>
        </section>


    )
}

export default TourOverView